export default {
  accessible_art: 'Доступное искусство',
  accessible_art_info: '* Всё то, что до 50 000₽',
  top_artists_art: 'Топ',
  new_art: 'Новинки месяца',
  top_artists: 'Художники',
  top_artists_info: '* Наше всё',
  top_institution: 'Институции',
  top_institutions_info: '* Здесь находятся работы, представленные галереями',
  how_connect: 'Хотите попасть в Галерею?',
  need_user: 'Отправляйте нам своё портфолио',
  need_guest: 'Нужно всего лишь зарегистрироваться и отправить нам своё портфолио',
  publish_art: 'Публиковать свои работы',
  top_collectors: 'Коллекционеры',
  top_collectors_info: '* Те, кто ценят по настоящему',
  top_dealers: 'Дилеры',
  top_dealers_info: '* Те, кто продает то, что вы сотворили',
  watch_all: 'Смотреть все работы на продажу',
};
